if (!customElements.get('wls-announcement-bar')) {
  class WLSAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'hidden',
        swiperClass: 'js-announcement-bar-slider',
        prevButton: 'js-swiper-btn-prev',
        nextButton: 'js-swiper-btn-next',
        sectionId: `${this.getAttribute('data-section-id')}`,
      };

      this.selectors = {
        swiperElement: this.querySelector(`.${this.classes.swiperClass}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
      };

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const rect = entry.boundingClientRect;
            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
            const height = visibleHeight > 0 ? visibleHeight : 0;
            document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
          });
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
      );
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      this.initializeSwiper();
      this.setAnnouncementBarHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));
      this.observer.observe(this);
    }

    /**
     * Initialize Swiper.
     *
     * @returns {void}
     */
    initializeSwiper() {
      const settingsElement = document.getElementById(`CarouselSettings-${this.classes.sectionId}`);
      const settings = JSON.parse(settingsElement.textContent);

      this.swiper = new Swiper(this.selectors.swiperElement, {
        loop: settings.loop,
        spaceBetween: 12,
        slidesPerView: 1,
        pagination: false,
        autoplay: {
          delay: settings.animationSpeed || 3000,
          enabled: settings.autoplay,
        },

        navigation: {
          prevEl: this.selectors.prevButton,
          nextEl: this.selectors.nextButton,
          enabled: true,
        },
      });

      if (!this.swiper.isLocked) {
        this.selectors.prevButton.classList.remove(this.classes.hidden);
        this.selectors.nextButton.classList.remove(this.classes.hidden);
      } else {
        this.selectors.prevButton.classList.add(this.classes.hidden);
        this.selectors.nextButton.classList.add(this.classes.hidden);
      }
    }

    setAnnouncementBarHeight() {
      const rect = this.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      const height = visibleHeight > 0 ? visibleHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }
  }

  window.customElements.define('wls-announcement-bar', WLSAnnouncementBar);
}
